/* import __COLOCATED_TEMPLATE__ from './continued-conversations-toggle-for-standalone.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

interface Args {
  visibilitySettings: $TSFixMe;
  disallowConversationReplyAfterSeconds: number;
  isUser: boolean;
  label: string;
  noContinuedConversationsEnabled: boolean;
  replyAfterLabel: string;
  onClick: () => void;
}

export default class ContinuedConversationsToggleForStandalone extends Component<Args> {
  @tracked delayInDays = this.args.disallowConversationReplyAfterSeconds / (60 * 60 * 24);

  @action
  updateDelay(event: Event): void {
    let target = event.target as HTMLInputElement;
    let value = Number.parseInt(target.value, 10);
    if (!isNaN(value)) {
      this.delayInDays = value;
      let delayInSeconds = this.delayInDays * 60 * 60 * 24;
      if (this.args.isUser) {
        this.args.visibilitySettings.disallowConversationReplyAfterSecondsForUsers = delayInSeconds;
      } else {
        this.args.visibilitySettings.disallowConversationReplyAfterSecondsForVisitors =
          delayInSeconds;
      }
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Content::ContinuedConversationsToggleForStandalone': typeof ContinuedConversationsToggleForStandalone;
    'messenger-settings/content/continued-conversations-toggle-for-standalone': typeof ContinuedConversationsToggleForStandalone;
  }
}
